







import axios from 'axios'
import store from './store'
import * as utils from '@ivy/fts/utils'
import { Component, Vue, Watch } from 'vue-property-decorator'
import * as weixin from '@ivy/fts/weixin'

@Component({})
export default class App extends Vue {
  transitionName: any = 'slide-left'
  noWxLoginPages: any = [
    '/shared/minipro',
    '/disclaimer',
    '/giftbags',
    '/privacy',
    '/baidulogin',
    '/activity/',
    '/use/',
    '/luckdraw',
    '/admin/appdownload',
  ]
  async created() {
    await utils.sleep(100)
    let { path } = this.$route
    if (!this.noWxLoginPages.includes(path.toLowerCase())) {
      await weixin.wxConfigReady()
      await store.login(this)
    }
  }
}
console.log('Powered by ivydad')
